import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DataMappingService} from '../services/data-mapping.service';
import {MitarbeiterBase} from '../dtos/mitarbeiterBase';

@Pipe({
  name: 'idToLaufnummern',
  standalone: false
})
export class IdToLaufnummernPipe implements PipeTransform {
  constructor(
    private readonly translateService: TranslateService,
    private readonly mapping: DataMappingService
  ) {}

  transform(
    values: unknown[] | unknown,
    mitarbeiters: MitarbeiterBase[]
  ): string | Promise<string> {
    if (!values || (values instanceof Array && values.length <= 0)) {
      return this.translateService.instant(
        'm2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.noData-laufnummer'
      );
    }
    let data: number[] = [];
    if (values instanceof Array) {
      data = values.map(Number);
    } else {
      data = [Number(values)];
    }
    if (mitarbeiters) {
      const result = this.mapping.mapMitarbeiterIdsToLaufnummern(
        data,
        mitarbeiters
      );
      return this.preparePipeOutput(result);
    }
    return this.mapping
      .mapMitarbeiterIdsToLaufnummernAsync(data)
      .then(result => this.preparePipeOutput(result));
  }

  private preparePipeOutput(result: string[]): string | Promise<string> {
    return result.join(', ');
  }
}
